import React, { useState } from "react";
import { FormattedMessage, FormattedNumber, useIntl } from "react-intl";
import { useSelector, useDispatch } from "react-redux";

import AvailabilityButton from "../AvailabilityButton";

import {
  checkOfferAction,
  clearMarketingActions,
  searchBetterOffers,
  setHotelOfferInfos,
  setOfferFlexbooked,
  setOfferId,
} from "amadeusredux/lib/hotelSlice";

import HotelOfferVoucher from "../components/HotelOfferVoucher";
import {
  boardTypes,
  dateAddMinute,
  propertyFromArray,
  roomViews,
  views,
} from "../utils";
import { availabilityAndPriceCheck } from "amadeusredux/lib/api";
import { currencySymbol } from "../utils.js";
import { selectSearch } from "amadeusredux/lib/searchSlice.js";
import { getalternativeTransports } from "../offerutils.js";

function useWindowSize() {
  const [size, setSize] = useState([0, 0]);
  React.useLayoutEffect(() => {
    function updateSize() {
      setSize([window.innerWidth, window.innerHeight]);
    }
    window.addEventListener("resize", updateSize);
    updateSize();
    return () => window.removeEventListener("resize", updateSize);
  }, []);
  return size;
}

const nf = new Intl.NumberFormat("de-DE", {
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
});

const checkDifference = (offer, suboffer) => {
  let betterOffer = 0;
  let betterOption = { better: false, options: [] };
  if (
    !(
      offer?.OfferServices?.Package?.Flight?.OutboundFlight.FlightDeparture
        .DepartureTime ===
        suboffer?.OfferServices?.Package?.Flight?.OutboundFlight.FlightDeparture
          .DepartureTime &&
      offer?.OfferServices?.Package?.Flight?.InboundFlight.FlightDeparture
        .DepartureTime ===
        suboffer?.OfferServices?.Package?.Flight?.InboundFlight.FlightDeparture
          .DepartureTime
    )
  )
    return betterOption;

  /*if (offer.PriceInfo.Price.value > suboffer.PriceInfo.Price.value)
    return betterOption;*/

  if (
    offer.TourOperator.TourOperatorName !==
    suboffer.TourOperator.TourOperatorName
  )
    return betterOption;

  if (offer.OfferID === suboffer.OfferID) return betterOption;

  betterOption.better = true;

  if (
    offer.OfferServices.Package.Accommodation.Room.RoomName !==
    suboffer.OfferServices.Package.Accommodation.Room.RoomName
  ) {
    betterOption.options.push("roomName");
  }

  if (
    offer.OfferServices.Package.Accommodation.Room.RoomView !==
    suboffer.OfferServices.Package.Accommodation.Room.RoomView
  ) {
    betterOption.options.push("roomView");
  }

  if (
    offer.OfferServices.Package.Accommodation.BoardType !==
    suboffer.OfferServices.Package.Accommodation.BoardType
  ) {
    betterOption.options.push("boardType");
  }

  let transferinclOffer = 0;
  if (offer?.OfferProperties?.TransferInfos) {
    if (
      Array.isArray(offer.OfferProperties.TransferInfos) &&
      offer.OfferProperties.TransferInfos.includes("TransferIncluded")
    ) {
      transferinclOffer = 1;
    }
  }

  let transferinclSubOffer = 0;
  if (suboffer?.OfferProperties?.TransferInfos) {
    if (
      Array.isArray(suboffer.OfferProperties.TransferInfos) &&
      suboffer.OfferProperties.TransferInfos.includes("TransferIncluded")
    ) {
      transferinclSubOffer = 1;
    }
  }

  if (transferinclSubOffer - transferinclOffer < 0) {
    betterOption.options.push("transferNotIncluded");
  }

  if (transferinclSubOffer - transferinclOffer > 0) {
    betterOption.options.push("transferIncluded");
  }

  let railandflyOffer = 0;
  if (offer?.OfferProperties?.OfferIncludes) {
    if (
      Array.isArray(offer.OfferProperties.OfferIncludes) &&
      offer.OfferProperties.OfferIncludes.includes("RailAndFly")
    ) {
      railandflyOffer = 1;
    }
  }

  let railandflySubOffer = 0;
  if (suboffer?.OfferProperties?.OfferIncludes) {
    if (
      Array.isArray(suboffer.OfferProperties.OfferIncludes) &&
      suboffer.OfferProperties.OfferIncludes.includes("RailAndFly")
    ) {
      railandflySubOffer = 1;
    }
  }

  if (railandflySubOffer - railandflyOffer < 0) {
    betterOption.options.push("railandflyNotIncluded");
  }

  if (railandflySubOffer - railandflyOffer > 0) {
    betterOption.options.push("railandflyIncluded");
  }

  let rentalcarOffer = 0;
  if (offer?.OfferProperties?.OfferIncludes) {
    if (
      Array.isArray(offer.OfferProperties.OfferIncludes) &&
      offer.OfferProperties.OfferIncludes.includes("RentalCar")
    ) {
      rentalcarOffer = 1;
    }
  }

  let rentalcarSubOffer = 0;
  if (suboffer?.OfferProperties?.OfferIncludes) {
    if (
      Array.isArray(suboffer.OfferProperties.OfferIncludes) &&
      suboffer.OfferProperties.OfferIncludes.includes("RentalCar")
    ) {
      rentalcarSubOffer = 1;
    }
  }

  if (rentalcarSubOffer - rentalcarOffer < 0) {
    betterOption.options.push("rentalcarNotIncluded");
  }

  if (rentalcarSubOffer - rentalcarOffer > 0) {
    betterOption.options.push("rentalcarIncluded");
  }

  let freerebookOffer = 0;
  if (offer?.OfferProperties?.OfferIncludes) {
    if (
      Array.isArray(offer.OfferProperties.OfferIncludes) &&
      offer.OfferProperties.OfferIncludes.includes("FreeRebooking")
    ) {
      freerebookOffer = 1;
    }
  }

  let freerebookSubOffer = 0;
  if (suboffer?.OfferProperties?.OfferIncludes) {
    if (
      Array.isArray(suboffer.OfferProperties.OfferIncludes) &&
      suboffer.OfferProperties.OfferIncludes.includes("FreeRebooking")
    ) {
      freerebookSubOffer = 1;
    }
  }

  if (freerebookSubOffer - freerebookOffer < 0) {
    betterOption.options.push("freerebookNotIncluded");
  }

  if (freerebookSubOffer - freerebookOffer > 0) {
    betterOption.options.push("freerebookIncluded");
  }

  let cancellationOffer = 0;
  if (offer?.OfferProperties?.CancellationOption === "Free")
    cancellationOffer = 3;
  if (offer?.OfferProperties?.CancellationOption === "Addable")
    cancellationOffer = 2;
  if (offer?.OfferProperties?.CancellationOption === "Paid")
    cancellationOffer = 1;

  let cancellationSubOffer = 0;
  if (suboffer?.OfferProperties?.CancellationOption === "Free")
    cancellationSubOffer = 3;
  if (suboffer?.OfferProperties?.CancellationOption === "Addable")
    cancellationSubOffer = 2;
  if (suboffer?.OfferProperties?.CancellationOption === "Paid")
    cancellationSubOffer = 1;

  if (cancellationSubOffer - cancellationOffer < 0) {
    betterOption.options.push("cancellationDowngrade");
  }

  if (cancellationSubOffer - cancellationOffer > 0) {
    betterOption.options.push("cancellationUpgrade");
  }

  return betterOption;
};

export default function HotelCrossViewOffer(props) {
  let {
    offer,
    otherRoomOffers,
    otherCancelOffers,
    otherBoardOffers,
    otherTransferOffer,
    otherRailOffer,
    otherViewOffers,
    stations,
    hotel,
    transferincl,
    cancellationoption,
    hotelOfferInfos,
    alternativeTransportsButton,
    railandfly,
    offsetTop,
    flexSelected,
    setFlexSelected,
  } = props;

  const [width, height] = useWindowSize();
  const intl = useIntl();
  //console.log(otherTransferOffer?.OfferID);
  //console.log(intl.locale);
  const df = new Intl.DateTimeFormat(intl.locale, {
    weekday: "short",
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
  });
  const dispatch = useDispatch();
  const sessionId = useSelector((state) => state.system.sessionId);

  const checkids = useSelector((state) => state.hotel.checkids);
  const holidayType = useSelector((state) => state.search.holidayType);
  const searchOptions = useSelector(selectSearch);
  /*const [referenceElement, setReferenceElement] = useState(null);
  const [popperElement, setPopperElement] = useState(null);
  const [arrowElement, setArrowElement] = useState(null);
  const { styles, attributes } = usePopper(referenceElement, popperElement, {
    placement: "top",
    modifiers: [{ name: "arrow", options: { element: arrowElement }}],
  });*/

  let status = 0;
  let even = false;
  if (offer?.bookinginfo) {
    if (
      offer?.bookinginfo?.Status?.Status === "Available" ||
      offer?.bookinginfo?.Status?.Status === "ToConfirm" ||
      offer?.bookinginfo?.Status?.Status === "OnRequest"
    ) {
      status = 1;
    } else {
      status = -1;
    }
  }

  let realprice = 0;

  if (offer?.bookinginfo?.PriceInformation?.TotalPrice?.Amount?._) {
    realprice = offer?.bookinginfo?.PriceInformation?.TotalPrice?.Amount?._ * 1;
  }

  /*if (document.getElementById("shareicon")){
    console.log("createpopper");
    createPopper(document.getElementById("shareicon"),document.getElementById("poppertooltip"),{
      placement:"top"
    })
  }*/
  const betterOffers = useSelector(
    (state) => state.hotel.betterOffers[offer.OfferID]
  );

  React.useEffect(() => {
    if (!(offer.alternativeTransport || offer.betterOffer)) return;

    let obf = offer?.OfferServices?.Package?.Flight?.OutboundFlight;
    let ibf = offer?.OfferServices?.Package?.Flight?.InboundFlight;

    dispatch(
      searchBetterOffers({
        fromDate: holidayType.flight
          ? obf.FlightDeparture.DepartureDate
          : offer.TravelDateInfo.CheckInDate,
        //outboundtime: "00:00-23:59",
        outboundtime: holidayType.flight
          ? obf.FlightDeparture.DepartureTime +
            "-" +
            dateAddMinute(obf.FlightDeparture.DepartureTime)
          : "",
        untilDate: holidayType.flight
          ? ibf.FlightDeparture.DepartureDate
          : offer.TravelDateInfo.CheckOutDate,
        inboundtime: holidayType.flight
          ? ibf.FlightDeparture.DepartureTime +
            "-" +
            dateAddMinute(ibf.FlightDeparture.DepartureTime)
          : "",
        //inboundtime: "00:00-23:59",
        station: holidayType.flight
          ? obf.FlightDeparture.DepartureAirportRef.AirportCode
          : "",

        touroperator: offer.TourOperator.TourOperatorCode,
        searchOptions: searchOptions,
        selectedDestination: [hotel],
        parentid: offer.OfferID,
        withActions: false,
        forceClear: false,
        cross: true,
        subload: false,
      })
    );
  }, [offer]);

  React.useEffect(() => {
    if (
      !offer?.bookinginfo &&
      Array.isArray(checkids) &&
      !checkids.includes(offer.OfferID)
    )
      availabilityAndPriceCheck(
        dispatch,
        sessionId,
        offer.OfferID,
        offer.adults,
        offer.children,
        undefined
      );
  }, [checkids, offer]);

  let ct = 0;

  if (otherRoomOffers.length > 0) {
    for (let i = 0; i < otherRoomOffers.length; i++) {
      let off = otherRoomOffers[i].offer;
      ct = ct + 1;
      if (
        ct <= 10 &&
        !off?.bookinginfo &&
        Array.isArray(checkids) &&
        !checkids.includes(off.OfferID)
      )
        availabilityAndPriceCheck(
          dispatch,
          sessionId,
          off.OfferID,
          off.adults,
          off.children,
          undefined
        );
    }
  }

  if (otherBoardOffers.length > 0) {
    for (let i = 0; i < otherBoardOffers.length; i++) {
      let off = otherBoardOffers[i].offer;
      ct = ct + 1;
      if (
        ct <= 10 &&
        !off?.bookinginfo &&
        Array.isArray(checkids) &&
        !checkids.includes(off.OfferID)
      )
        availabilityAndPriceCheck(
          dispatch,
          sessionId,
          off.OfferID,
          off.adults,
          off.children,
          undefined
        );
    }
  }
  if (otherViewOffers.length > 0) {
    for (let i = 0; i < otherViewOffers.length; i++) {
      let off = otherViewOffers[i].offer;
      ct = ct + 1;
      if (
        ct <= 10 &&
        !off?.bookinginfo &&
        Array.isArray(checkids) &&
        !checkids.includes(off.OfferID)
      )
        availabilityAndPriceCheck(
          dispatch,
          sessionId,
          off.OfferID,
          off.adults,
          off.children,
          undefined
        );
    }
  }

  if (otherTransferOffer.OfferID && ct < 10) {
    let off = otherTransferOffer;
    ct = ct + 1;
    if (
      ct <= 10 &&
      !off?.bookinginfo &&
      Array.isArray(checkids) &&
      !checkids.includes(off.OfferID)
    )
      availabilityAndPriceCheck(
        dispatch,
        sessionId,
        off.OfferID,
        off.adults,
        off.children,
        undefined
      );
  }

  if (otherRailOffer.OfferID && ct < 10) {
    let off = otherRailOffer;
    ct = ct + 1;
    if (
      ct <= 10 &&
      !off?.bookinginfo &&
      Array.isArray(checkids) &&
      !checkids.includes(off.OfferID)
    )
      availabilityAndPriceCheck(
        dispatch,
        sessionId,
        off.OfferID,
        off.adults,
        off.children,
        undefined
      );
  }

  let offerrealprice = 0;
  let offerbetterprice = 0;

  if (offer?.bookinginfo?.PriceInformation?.TotalPrice?.Amount?._) {
    offerrealprice =
      offer?.bookinginfo?.PriceInformation?.TotalPrice?.Amount?._ * 1;
    offerbetterprice =
      offer?.bookinginfo?.PriceInformation?.TotalPrice?.Amount?._ * 1;
  } else {
    offerrealprice =
      offer.PriceInfo.Price.value * (offer.adults * 1 + offer.children * 1);
    offerbetterprice =
      offer.PriceInfo.Price.value * (offer.adults * 1 + offer.children * 1);
  }

  if (
    Array.isArray(offer?.MarketingActions) &&
    offer?.MarketingActions.length > 0 &&
    offer?.MarketingActions[0].flexconditions?.flexoptions?.flexoptionprice &&
    flexSelected
  ) {
    offerbetterprice +=
      offer.MarketingActions[0].flexconditions?.flexoptions?.flexoptionprice *
      1;
  }

  let transferofferrealprice = 0;

  if (otherTransferOffer.OfferID) {
    if (
      otherTransferOffer?.bookinginfo?.PriceInformation?.TotalPrice?.Amount?._
    ) {
      transferofferrealprice =
        otherTransferOffer?.bookinginfo?.PriceInformation?.TotalPrice?.Amount
          ?._ * 1;
    } else {
      transferofferrealprice =
        otherTransferOffer.PriceInfo.Price.value *
        (offer.adults * 1 + offer.children * 1);
    }
    if (
      Array.isArray(otherTransferOffer?.MarketingActions) &&
      otherTransferOffer.MarketingActions.length > 0 &&
      otherTransferOffer.MarketingActions[0].flexconditions?.flexoptions
        ?.flexoptionprice &&
      flexSelected
    ) {
      transferofferrealprice +=
        otherTransferOffer.MarketingActions[0].flexconditions?.flexoptions
          ?.flexoptionprice * 1;
    }
  }

  let railofferrealprice = 0;

  if (otherRailOffer.OfferID) {
    if (otherRailOffer?.bookinginfo?.PriceInformation?.TotalPrice?.Amount?._) {
      railofferrealprice =
        otherRailOffer?.bookinginfo?.PriceInformation?.TotalPrice?.Amount?._ *
        1;
    } else {
      railofferrealprice =
        otherRailOffer.PriceInfo.Price.value *
        (offer.adults * 1 + offer.children * 1);
    }
    if (
      Array.isArray(otherRailOffer?.MarketingActions) &&
      otherRailOffer.MarketingActions.length > 0 &&
      otherRailOffer.MarketingActions[0].flexconditions?.flexoptions
        ?.flexoptionprice &&
      flexSelected
    ) {
      railofferrealprice +=
        otherRailOffer.MarketingActions[0].flexconditions?.flexoptions
          ?.flexoptionprice * 1;
    }
  }

  //console.log(offer);

  return (
    <>
      {/*<div
        style={{
          marginTop: 16,
          boxSizing: "border-box",
          borderRadius: "18px 18px 0px 0px",
          boxShadow: " 0px 3px 15px 0px rgba(0, 0, 0, 0.1)",
          backgroundColor: "rgba(255,255,255,0.1)",
        }}
      >*/}

      <HotelOfferVoucher
        offer={offer}
        availabilityButton={
          <AvailabilityButton
            isVoucher={true}
            offer={offer}
            hotel={hotel}
            inboundView={views.hotelcrossview}
          />
        }
        alternativeTransportsButton={alternativeTransportsButton}
      />

      {/*</div>*/}

      {(otherRoomOffers.length > 0 ||
        otherBoardOffers.length > 0 ||
        otherViewOffers.length > 0 ||
        otherTransferOffer.OfferID ||
        otherRailOffer.OfferID ||
        otherCancelOffers.length > 0 ||
        offer.betterOffer ||
        offer.alternativeTransport ||
        (Array.isArray(offer.MarketingActions) &&
          offer.MarketingActions.length > 0 &&
          !isNaN(
            offer.MarketingActions[0].flexconditions?.flexoptions
              ?.flexoptionprice
          ) &&
          offer.MarketingActions[0].flexconditions?.flexoptions
            ?.flexoption)) && (
        <div className="offerupgradeframe">
          <div className="offerupgradeheadline">Bessere Leistungen </div>
          <div className="offerupgrades">
            {Array.isArray(offer.MarketingActions) &&
              offer.MarketingActions.length > 0 &&
              !isNaN(
                offer.MarketingActions[0].flexconditions?.flexoptions
                  ?.flexoptionprice
              ) &&
              offer.MarketingActions[0].flexconditions?.flexoptions
                ?.flexoption && (
                <div className="offerupgrade">
                  <div className="offerupgradelabel">
                    {
                      offer.MarketingActions[0].flexconditions?.flexoptions
                        ?.flexoptiontext
                    }
                  </div>

                  <div className="offerupgradeitem">
                    <div className="offerupgradeitemlabelflex">
                      {offer.flexbooked
                        ? "Flexoption entfernen"
                        : "Flexoption zubuchen"}
                    </div>
                    <div
                      className="offerupgradeitemprice"
                      onClick={() => {
                        //window.scrollTo(0, offsetTop);
                        //dispatch(setOfferId(otherRailOffer.OfferID));
                      }}
                    >
                      {!offer.flexbooked ? <>+&nbsp;</> : <>-&nbsp;</>}
                      {nf.format(
                        offer.MarketingActions[0].flexconditions?.flexoptions
                          ?.flexoptionprice
                      )}{" "}
                      {offer.PriceInfo.Price.CurrencyCode}
                      &nbsp;&nbsp;(
                      {nf.format(
                        offerrealprice +
                          offer.MarketingActions[0].flexconditions?.flexoptions
                            ?.flexoptionprice *
                            (offer.flexbooked ? 0 : 1)
                      )}{" "}
                      {offer.PriceInfo.Price.CurrencyCode})
                    </div>
                    <div
                      style={{
                        paddingLeft: 8,
                        display: "flex",
                        flexDirection: "column",
                      }}
                    >
                      <AvailabilityButton
                        offer={offer}
                        hotel={hotel}
                        inboundView={views.hotelcrossview}
                        availableAction={(off) => {
                          window.scrollTo(0, offsetTop);
                          setFlexSelected(!offer.flexbooked);
                          //dispatch(clearMarketingActions(offer.OfferID));
                          /*dispatch(
                            checkOfferAction({
                              offerId: offer.OfferID,
                              offer: {
                                ...offer,
                                flexbooked: !offer.flexbooked,
                              },
                            })
                          );*/

                          dispatch(
                            setOfferFlexbooked({
                              offerId: offer.OfferID,
                              flexbooked: !offer.flexbooked,
                            })
                          );

                          dispatch(setOfferId(offer.OfferID));
                        }}
                        availableText={"übernehmen"}
                      />
                      <div className="growbox" />
                    </div>
                  </div>
                </div>
              )}
            {!(offer.alternativeTransport || offer.betterOffer) &&
              otherRoomOffers.length > 0 && (
                <div className="offerupgrade">
                  {otherRoomOffers.length > 0 && (
                    <div className="offerupgradelabel">Zimmerart</div>
                  )}
                  {otherRoomOffers.map((e, i) => {
                    let erealprice = 0;

                    if (
                      e?.offer?.bookinginfo?.PriceInformation?.TotalPrice
                        ?.Amount?._
                    ) {
                      erealprice =
                        e?.offer?.bookinginfo?.PriceInformation?.TotalPrice
                          ?.Amount?._ * 1;
                    } else {
                      erealprice =
                        e.offer.PriceInfo.Price.value *
                        (offer.adults * 1 + offer.children * 1);
                    }
                    if (
                      Array.isArray(e?.offer?.MarketingActions) &&
                      e.offer.MarketingActions.length > 0 &&
                      e.offer.MarketingActions[0].flexconditions?.flexoptions
                        ?.flexoptionprice &&
                      flexSelected
                    ) {
                      erealprice +=
                        e.offer.MarketingActions[0].flexconditions?.flexoptions
                          ?.flexoptionprice * 1;
                    }
                    return (
                      <div
                        className={
                          i % 2 === 0
                            ? "offerupgradeitem1"
                            : "offerupgradeitem2"
                        }
                      >
                        <div className="offerupgradeitemlabel">{e.label}</div>
                        <div
                          className="offerupgradeitemprice"
                          onClick={() => {
                            //window.scrollTo(0, offsetTop);
                            //dispatch(setOfferId(e.offer.OfferID));
                          }}
                        >
                          {erealprice > offerbetterprice ? (
                            <>+&nbsp;</>
                          ) : (
                            <>-&nbsp;</>
                          )}
                          {nf.format(
                            Math.abs(erealprice - offerbetterprice).toFixed(0)
                          )}{" "}
                          {currencySymbol(e.offer.PriceInfo.Price.CurrencyCode)}
                          &nbsp;&nbsp;(
                          {nf.format(erealprice)}{" "}
                          {currencySymbol(e.offer.PriceInfo.Price.CurrencyCode)}
                          )
                        </div>
                        <div
                          style={{
                            paddingLeft: 8,
                            display: "flex",
                            flexDirection: "column",
                          }}
                        >
                          <AvailabilityButton
                            offer={e.offer}
                            hotel={hotel}
                            inboundView={views.hotelcrossview}
                            availableAction={(off) => {
                              dispatch(
                                setOfferFlexbooked({
                                  offerId: e.offer.OfferID,
                                  flexbooked: flexSelected,
                                })
                              );
                              window.scrollTo(0, offsetTop);
                              dispatch(setOfferId(e.offer.OfferID));
                            }}
                            availableText={"übernehmen"}
                          />
                          <div className="growbox" />
                        </div>
                      </div>
                    );
                  })}
                </div>
              )}

            {!(offer.alternativeTransport || offer.betterOffer) &&
              otherBoardOffers.length > 0 && (
                <div className="offerupgrade">
                  {otherBoardOffers.length > 0 && (
                    <div className="offerupgradelabel">Verpflegung</div>
                  )}
                  {otherBoardOffers.map((e, i) => {
                    let erealprice = 0;

                    if (
                      e?.offer?.bookinginfo?.PriceInformation?.TotalPrice
                        ?.Amount?._
                    ) {
                      erealprice =
                        e?.offer?.bookinginfo?.PriceInformation?.TotalPrice
                          ?.Amount?._ * 1;
                    } else {
                      erealprice =
                        e.offer.PriceInfo.Price.value *
                        (offer.adults * 1 + offer.children * 1);
                    }

                    if (
                      Array.isArray(e?.offer?.MarketingActions) &&
                      e.offer.MarketingActions.length > 0 &&
                      e.offer.MarketingActions[0].flexconditions?.flexoptions
                        ?.flexoptionprice &&
                      flexSelected
                    ) {
                      erealprice +=
                        e.offer.MarketingActions[0].flexconditions?.flexoptions
                          ?.flexoptionprice * 1;
                    }

                    return (
                      <div
                        className={
                          i % 2 === 0
                            ? "offerupgradeitem1"
                            : "offerupgradeitem2"
                        }
                      >
                        <div className="offerupgradeitemlabel">{e.label} </div>
                        <div
                          className="offerupgradeitemprice"
                          onClick={() => {
                            //window.scrollTo(0, offsetTop);
                            //dispatch(setOfferId(e.offer.OfferID));
                          }}
                        >
                          {erealprice > offerbetterprice ? (
                            <>+&nbsp;</>
                          ) : (
                            <>-&nbsp;</>
                          )}
                          {nf.format(
                            Math.abs(erealprice - offerbetterprice).toFixed(0)
                          )}{" "}
                          {currencySymbol(e.offer.PriceInfo.Price.CurrencyCode)}
                          &nbsp;&nbsp;(
                          {erealprice}{" "}
                          {currencySymbol(e.offer.PriceInfo.Price.CurrencyCode)}
                          )
                        </div>
                        <div
                          style={{
                            paddingLeft: 8,
                            display: "flex",
                            flexDirection: "column",
                          }}
                        >
                          <AvailabilityButton
                            offer={e.offer}
                            hotel={hotel}
                            inboundView={views.hotelcrossview}
                            availableAction={(off) => {
                              dispatch(
                                setOfferFlexbooked({
                                  offerId: e.offer.OfferID,
                                  flexbooked: flexSelected,
                                })
                              );
                              window.scrollTo(0, offsetTop);
                              dispatch(setOfferId(e.offer.OfferID));
                            }}
                            availableText={"übernehmen"}
                          />
                          <div className="growbox" />
                        </div>
                      </div>
                    );
                  })}
                </div>
              )}
            {!(offer.alternativeTransport || offer.betterOffer) &&
              otherViewOffers.length > 0 && (
                <div className="offerupgrade">
                  {otherViewOffers.length > 0 && (
                    <div className="offerupgradelabel">Aussicht </div>
                  )}
                  {otherViewOffers.map((e, i) => {
                    let erealprice = 0;

                    if (
                      e?.offer?.bookinginfo?.PriceInformation?.TotalPrice
                        ?.Amount?._
                    ) {
                      erealprice =
                        e?.offer?.bookinginfo?.PriceInformation?.TotalPrice
                          ?.Amount?._ * 1;
                    } else {
                      erealprice =
                        e.offer.PriceInfo.Price.value *
                        (offer.adults * 1 + offer.children * 1);
                    }
                    if (
                      Array.isArray(e?.offer?.MarketingActions) &&
                      e.offer.MarketingActions.length > 0 &&
                      e.offer.MarketingActions[0].flexconditions?.flexoptions
                        ?.flexoptionprice &&
                      flexSelected
                    ) {
                      erealprice +=
                        e.offer.MarketingActions[0].flexconditions?.flexoptions
                          ?.flexoptionprice * 1;
                    }

                    return (
                      <div
                        className={
                          i % 2 === 0
                            ? "offerupgradeitem1"
                            : "offerupgradeitem2"
                        }
                      >
                        <div className="offerupgradeitemlabel">{e.label} </div>
                        <div
                          className="offerupgradeitemprice"
                          onClick={() => {
                            //window.scrollTo(0, offsetTop);
                            //dispatch(setOfferId(e.offer.OfferID));
                          }}
                        >
                          {erealprice > offerbetterprice ? (
                            <>+&nbsp;</>
                          ) : (
                            <>-&nbsp;</>
                          )}
                          {nf.format(
                            Math.abs(erealprice - offerbetterprice).toFixed(0)
                          )}{" "}
                          {currencySymbol(e.offer.PriceInfo.Price.CurrencyCode)}
                          &nbsp;&nbsp;(
                          {erealprice}{" "}
                          {currencySymbol(e.offer.PriceInfo.Price.CurrencyCode)}
                          )
                        </div>
                        <div
                          style={{
                            paddingLeft: 8,
                            display: "flex",
                            flexDirection: "column",
                          }}
                        >
                          <AvailabilityButton
                            offer={e.offer}
                            hotel={hotel}
                            inboundView={views.hotelcrossview}
                            availableAction={(off) => {
                              dispatch(
                                setOfferFlexbooked({
                                  offerId: e.offer.OfferID,
                                  flexbooked: flexSelected,
                                })
                              );
                              window.scrollTo(0, offsetTop);
                              dispatch(setOfferId(e.offer.OfferID));
                            }}
                            availableText={"übernehmen"}
                          />
                          <div className="growbox" />
                        </div>
                      </div>
                    );
                  })}
                </div>
              )}
            {!(offer.alternativeTransport || offer.betterOffer) &&
              otherTransferOffer.OfferID && (
                <div className="offerupgrade">
                  {otherTransferOffer.OfferID && (
                    <div className="offerupgradelabel">Transfer </div>
                  )}
                  {otherTransferOffer.OfferID && (
                    <div className="offerupgradeitem">
                      <div className="offerupgradeitemlabel">
                        {transferincl ? (
                          <FormattedMessage id="transferremove" />
                        ) : (
                          <FormattedMessage id="transferadd" />
                        )}
                      </div>
                      <div
                        className="offerupgradeitemprice"
                        onClick={() => {
                          //window.scrollTo(0, offsetTop);
                          //dispatch(setOfferId(otherTransferOffer.OfferID));
                        }}
                      >
                        {transferofferrealprice > offerbetterprice ? (
                          <>+&nbsp;</>
                        ) : (
                          <>-&nbsp;</>
                        )}
                        {nf.format(
                          Math.abs(
                            transferofferrealprice - offerbetterprice
                          ).toFixed(0)
                        )}{" "}
                        {currencySymbol(
                          otherTransferOffer.PriceInfo.Price.CurrencyCode
                        )}
                        &nbsp;&nbsp;(
                        {transferofferrealprice}{" "}
                        {currencySymbol(
                          otherTransferOffer.PriceInfo.Price.CurrencyCode
                        )}
                        )
                      </div>
                      <div
                        style={{
                          paddingLeft: 8,
                          display: "flex",
                          flexDirection: "column",
                        }}
                      >
                        <AvailabilityButton
                          offer={otherTransferOffer}
                          hotel={hotel}
                          inboundView={views.hotelcrossview}
                          availableAction={(off) => {
                            dispatch(
                              setOfferFlexbooked({
                                offerId: otherTransferOffer.OfferID,
                                flexbooked: flexSelected,
                              })
                            );
                            window.scrollTo(0, offsetTop);
                            dispatch(setOfferId(otherTransferOffer.OfferID));
                          }}
                          availableText={"übernehmen"}
                        />
                        <div className="growbox" />
                      </div>
                    </div>
                  )}
                </div>
              )}
            {!(offer.alternativeTransport || offer.betterOffer) &&
              otherRailOffer.OfferID && (
                <div className="offerupgrade">
                  {otherRailOffer.OfferID && (
                    <div className="offerupgradelabel">Zug zum Flug</div>
                  )}
                  {otherRailOffer.OfferID && (
                    <div className="offerupgradeitem">
                      <div className="offerupgradeitemlabel">
                        {railandfly
                          ? "Zug zum Flug entfernen"
                          : "Zug zum Flug zubuchen"}
                      </div>
                      <div
                        className="offerupgradeitemprice"
                        onClick={() => {
                          //window.scrollTo(0, offsetTop);
                          //dispatch(setOfferId(otherRailOffer.OfferID));
                        }}
                      >
                        {railofferrealprice > offerbetterprice ? (
                          <>+&nbsp;</>
                        ) : (
                          <>-&nbsp;</>
                        )}
                        {nf.format(
                          Math.abs(
                            railofferrealprice - offerbetterprice
                          ).toFixed(0)
                        )}{" "}
                        {currencySymbol(
                          otherRailOffer.PriceInfo.Price.CurrencyCode
                        )}
                        &nbsp;&nbsp;(
                        {railofferrealprice}{" "}
                        {currencySymbol(
                          otherRailOffer.PriceInfo.Price.CurrencyCode
                        )}
                        )
                      </div>
                      <div
                        style={{
                          paddingLeft: 8,
                          display: "flex",
                          flexDirection: "column",
                        }}
                      >
                        <AvailabilityButton
                          offer={otherRailOffer}
                          hotel={hotel}
                          inboundView={views.hotelcrossview}
                          availableAction={(off) => {
                            dispatch(
                              setOfferFlexbooked({
                                offerId: otherRailOffer.OfferID,
                                flexbooked: flexSelected,
                              })
                            );
                            window.scrollTo(0, offsetTop);
                            dispatch(setOfferId(otherRailOffer.OfferID));
                          }}
                          availableText={"übernehmen"}
                        />
                        <div className="growbox" />
                      </div>
                    </div>
                  )}
                </div>
              )}

            {!(offer.alternativeTransport || offer.betterOffer) &&
              otherCancelOffers.length > 0 && (
                <div className="offerupgrade">
                  {otherCancelOffers.length > 0 && (
                    <div className="offerupgradelabel">Stornooptionen</div>
                  )}
                  {otherCancelOffers.map((e, i) => {
                    let erealprice = 0;

                    if (
                      e?.offer?.bookinginfo?.PriceInformation?.TotalPrice
                        ?.Amount?._
                    ) {
                      erealprice =
                        e?.offer?.bookinginfo?.PriceInformation?.TotalPrice
                          ?.Amount?._ * 1;
                    } else {
                      erealprice =
                        e.offer.PriceInfo.Price.value *
                        (offer.adults * 1 + offer.children * 1);
                    }

                    if (
                      Array.isArray(e?.offer?.MarketingActions) &&
                      e.offer.MarketingActions.length > 0 &&
                      e.offer.MarketingActions[0].flexconditions?.flexoptions
                        ?.flexoptionprice &&
                      flexSelected
                    ) {
                      erealprice +=
                        e.offer.MarketingActions[0].flexconditions?.flexoptions
                          ?.flexoptionprice * 1;
                    }
                    return (
                      <div
                        className={
                          i % 2 === 0
                            ? "offerupgradeitem1"
                            : "offerupgradeitem2"
                        }
                      >
                        <div className="offerupgradeitemlabel">{e.label} </div>
                        <div
                          className="offerupgradeitemprice"
                          onClick={() => {
                            //window.scrollTo(0, offsetTop);
                            //dispatch(setOfferId(e.offer.OfferID));
                          }}
                        >
                          {erealprice > offerbetterprice ? (
                            <>+&nbsp;</>
                          ) : (
                            <>-&nbsp;</>
                          )}
                          {nf.format(
                            Math.abs(erealprice - offerbetterprice).toFixed(0)
                          )}{" "}
                          {currencySymbol(e.offer.PriceInfo.Price.CurrencyCode)}
                          &nbsp;&nbsp;(
                          {erealprice}{" "}
                          {currencySymbol(e.offer.PriceInfo.Price.CurrencyCode)}
                          )
                        </div>
                        <div
                          style={{
                            paddingLeft: 8,
                            display: "flex",
                            flexDirection: "column",
                          }}
                        >
                          <AvailabilityButton
                            offer={e.offer}
                            hotel={hotel}
                            inboundView={views.hotelcrossview}
                            availableAction={(off) => {
                              dispatch(
                                setOfferFlexbooked({
                                  offerId: e.offer.OfferID,
                                  flexbooked: flexSelected,
                                })
                              );
                              window.scrollTo(0, offsetTop);
                              dispatch(setOfferId(e.offer.OfferID));
                            }}
                            availableText={"übernehmen"}
                          />
                          <div className="growbox" />
                        </div>
                      </div>
                    );
                  })}
                </div>
              )}
            {(offer.alternativeTransport || offer.betterOffer) &&
              Array.isArray(betterOffers?.Offers?.Offer) &&
              betterOffers.Offers.Offer.map((suboffer, i) => {
                //let betterOption = checkBetter(offer, suboffer);
                let betterOption = checkDifference(offer, suboffer);
                //console.log(betterOption);
                if (betterOption.better) {
                  even = !even;
                  ct = ct + 1;
                }
                if (
                  ct <= 10 &&
                  betterOption.better &&
                  !suboffer?.bookinginfo &&
                  Array.isArray(checkids) &&
                  !checkids.includes(suboffer.OfferID)
                ) {
                  availabilityAndPriceCheck(
                    dispatch,
                    sessionId,
                    suboffer.OfferID,
                    suboffer.adults,
                    suboffer.children,
                    offer.OfferID
                  );
                }
                //outboundFlight.FlightDeparture.DepartureTime
                return betterOption.better ? (
                  //return true ? (
                  <div
                    className={even ? "offerupgradeitem1" : "offerupgradeitem2"}
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      marginBottom: 8,
                    }}
                  >
                    {/*JSON.stringify(betterOption)*/}
                    <br />

                    <div
                      className="offerupgradeitemlabel"
                      //style={{ fontSize: "12pt" }}
                    >
                      {Array.isArray(betterOption?.options) &&
                        betterOption.options.map((option) => {
                          let optionsign = "+";
                          let optionvalue = "";
                          if (option === "roomName")
                            optionvalue =
                              suboffer.OfferServices.Package.Accommodation.Room
                                .RoomName;
                          if (
                            option === "roomView" &&
                            suboffer.OfferServices.Package.Accommodation.Room
                              .RoomView !== "NothingSpecial"
                          )
                            optionvalue = propertyFromArray(
                              roomViews,
                              suboffer.OfferServices.Package.Accommodation.Room
                                .RoomView,
                              "value",
                              "label"
                            );
                          if (
                            option === "roomView" &&
                            suboffer.OfferServices.Package.Accommodation.Room
                              .RoomView === "NothingSpecial"
                          ) {
                            optionsign = "-";
                            optionvalue = "keine definierte Aussicht";
                          }
                          if (option === "boardType")
                            optionvalue = propertyFromArray(
                              boardTypes,
                              suboffer.OfferServices.Package.Accommodation
                                .BoardType,
                              "value",
                              "label"
                            );

                          if (option === "transferNotIncluded") {
                            optionsign = "-";
                            optionvalue = "Hoteltransfer im Zielgebiet";
                          }
                          if (option === "transferIncluded")
                            optionvalue = "Hoteltransfer im Zielgebiet";
                          if (option === "railandflyNotIncluded") {
                            optionsign = "-";
                            optionvalue = "Rail&Fly";
                          }
                          if (option === "railandflyIncluded")
                            optionvalue = "Rail&Fly";
                          if (option === "rentalcarNotIncluded") {
                            optionsign = "-";
                            optionvalue = "Mietwagen";
                          }
                          if (option === "rentalcarIncluded")
                            optionvalue = "Mietwagen";
                          if (option === "freerebookNotIncluded") {
                            optionsign = "-";
                            optionvalue = "kostenlose Umbuchung";
                          }
                          if (option === "freerebookIncluded")
                            optionvalue = "kostenlose Umbuchung";

                          let cancellationoption = "";
                          if (suboffer?.OfferProperties?.CancellationOption) {
                            cancellationoption =
                              suboffer?.OfferProperties?.CancellationOption;
                          }

                          if (option === "cancellationDowngrade") {
                            optionsign = "-";
                            optionvalue = "Cancellation" + cancellationoption;
                          }
                          if (option === "cancellationUpgrade")
                            optionvalue = "Cancellation" + cancellationoption;

                          return (
                            <div style={{ display: "flex" }}>
                              {optionsign === "-" && (
                                <>
                                  <div style={{ minWidth: 15 }}>
                                    {optionsign}
                                  </div>{" "}
                                </>
                              )}
                              <div>{optionvalue} </div>
                            </div>
                          );
                        })}
                    </div>

                    <Offerprice
                      dispatch={dispatch}
                      clickAction={(off) => {
                        let theoff = { ...off };
                        theoff.flexbooked = flexSelected;
                        props.changeChoosenOffers(off);
                      }}
                      flexSelected={flexSelected}
                      offer={offer}
                      co={suboffer}
                    />
                    <div
                      style={{
                        paddingLeft: 8,
                        display: "flex",
                        flexDirection: "column",
                      }}
                    >
                      <AvailabilityButton
                        offer={suboffer}
                        hotel={hotel}
                        inboundView={views.hotelclassicview}
                        parentid={offer.OfferID}
                        availableAction={(off) => {
                          if (Array.isArray(hotelOfferInfos?.Offers?.Offer)) {
                            let tmp = [...hotelOfferInfos.Offers.Offer];
                            let found = false;
                            for (let i = 0; i < tmp.length; i++) {
                              if (tmp[i].OfferID === off.OfferID) {
                                found = true;
                                break;
                              }
                            }

                            if (!found) {
                              tmp.push(off);
                              let offs = { ...hotelOfferInfos.Offers };
                              offs.OfferCount = offs.OfferCount + 1;
                              offs.Offer = [...tmp];
                              dispatch(
                                setHotelOfferInfos({
                                  ...hotelOfferInfos,
                                  Offers: offs,
                                })
                              );
                            }
                          }

                          dispatch(
                            setOfferFlexbooked({
                              offerId: off.OfferID,
                              flexbooked: flexSelected,
                            })
                          );
                          window.scrollTo(0, offsetTop);
                          dispatch(setOfferId(off.OfferID));
                        }}
                        availableText={"übernehmen"}
                      />
                    </div>
                    {/*<HotelOfferFrame
                  alternatives={false}
                  offer={suboffer}
                  hotels={hotels}
                  geodata={geodata}
                  stations={betterOffers.StationDictionary}
                  searchOptions={searchOptions}
                  parentOffer={offer}
                  betterOption={betterOption}
              />*/}
                  </div>
                ) : null;
              })}
          </div>
        </div>
      )}
    </>
  );
}

const Offerprice = (props) => {
  const { co, offer, clickAction, flexSelected } = props;

  let offerrealprice = 0;

  if (offer?.bookinginfo?.PriceInformation?.TotalPrice?.Amount?._) {
    offerrealprice =
      offer?.bookinginfo?.PriceInformation?.TotalPrice?.Amount?._ * 1;
  } else {
    offerrealprice =
      offer.PriceInfo.Price.value * (offer.adults * 1 + offer.children * 1);
  }

  if (
    Array.isArray(offer?.MarketingActions) &&
    offer.MarketingActions.length > 0 &&
    offer.MarketingActions[0].flexconditions?.flexoptions?.flexoptionprice &&
    flexSelected
  ) {
    offerrealprice +=
      offer.MarketingActions[0].flexconditions?.flexoptions?.flexoptionprice *
      1;
  }

  let corealprice = 0;

  if (co?.bookinginfo?.PriceInformation?.TotalPrice?.Amount?._) {
    corealprice = co?.bookinginfo?.PriceInformation?.TotalPrice?.Amount?._ * 1;
  } else {
    corealprice =
      co.PriceInfo.Price.value * (offer.adults * 1 + offer.children * 1);
  }

  if (
    co.OfferID !== offer.OfferID &&
    co.PriceInfo.Price.value * (offer.adults * 1 + offer.children * 1) ===
      offer.PriceInfo.Price.value * (offer.adults * 1 + offer.children * 1)
  ) {
    console.log("ACHTUNG, WARUM GLEICH?", co, offer);
  }

  if (
    Array.isArray(offer?.MarketingActions) &&
    offer.MarketingActions.length > 0 &&
    offer.MarketingActions[0].flexconditions?.flexoptions?.flexoptionprice &&
    flexSelected
  ) {
    corealprice +=
      offer.MarketingActions[0].flexconditions?.flexoptions?.flexoptionprice *
      1;
  }

  return (
    <div
      style={{ display: "flex", flexDirection: "column" }}
      className="offerupgradeitemprice"
      onClick={() => {
        //clickAction(co)
      }}
    >
      <div className="growbox"></div>
      <div>
        {corealprice > offerrealprice ? <>+&nbsp;</> : <>-&nbsp;</>}
        {nf.format(Math.abs(corealprice - offerrealprice).toFixed(0))} EUR
        &nbsp;(
        {nf.format(corealprice)} EUR)
      </div>
    </div>
  );
};
